import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { defineComponent } from 'vue';
import Banner from '@/components/Banner.vue';
import NavHeader from '@/components/NavHeader.vue';
import ExcellentWorkGrid from '@/components/ExcellentWorkGrid.vue';
import Search from './components/Search.vue';
import { UserCreationService } from '@/services/userCreation.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import BannerImage from '@/assets/image/banner/banner2@2x.png';
export default defineComponent({
  name: 'UserExcellent',
  components: {
    Banner: Banner,
    NavHeader: NavHeader,
    ExcellentWorkGrid: ExcellentWorkGrid,
    Search: Search
  },
  setup: function setup() {
    declareProviders([UserCreationService]);
    var userCreationService = useService(UserCreationService);
    userCreationService.getActivityTypeList().then(function () {
      userCreationService.resetSearch();
    });

    var onPageNumChange = function onPageNumChange(page) {
      userCreationService.setPageNum(page);
      userCreationService.search();
    };

    var onShowSizeChange = function onShowSizeChange(current, pageSize) {
      userCreationService.setPageNum(current);
      userCreationService.setPageSize(pageSize);
      userCreationService.search();
    };

    var onActivityTypeChange = function onActivityTypeChange(item) {
      userCreationService.setActivityType(item.code);
      userCreationService.resetSearch();
    };

    return {
      BannerImage: BannerImage,
      userCreationService: userCreationService,
      onPageNumChange: onPageNumChange,
      onShowSizeChange: onShowSizeChange,
      onActivityTypeChange: onActivityTypeChange
    };
  }
});